import * as angular from "angular";
import {TableColumnSizeType} from "../../commons/types/table-column-size.type";
import {FulfillmentStepDisplayStatusGroupType} from "../types/fulfillment-step-display-status-group.type";
import {FulfillmentStepDisplayStatusType} from "../types/fulfillment-step-display-status.type";


const fulfillmentStatuses = [
  'Pending',
  'Started',
  'Completed',
  'Canceled',
  'Failed'
];

const fulfillmentDisplayStatuses = [
  'Cancelled',
  'OnHold',
  'InTransit',
  'Completed',
  'PartiallyDelivered',
  'DestinationInProgress',
  'PickedUp',
  'PartiallyPickedUp',
  'PickupInProgress',
  'Scheduled',
  'Pending'
]

const fulfillmentStepStatuses = [
  'Pending',
  'Scheduled',
  'Dispatched',
  'OnHold',
  'Completed',
  'Canceled',
  'Failed',
  'Splitted'
]

const fulfillmentMiles = [
  'firstMile',
  'middleMile',
  'lastMile'
]

const fulfillmentLinesTableColumnsMap = {
  account: {enabled: true, order: 1, isOptional: true, permission: undefined},
  displayStatus: {enabled: true, order: 2, isOptional: true, permission: undefined},
  line: {enabled: true, order: 3, isOptional: true, permission: undefined},
  pickupTask: {enabled: true, order: 4, isOptional: true, permission: undefined},
  dropoffTask: {enabled: true, order: 5, isOptional: true, permission: undefined},
  stepsStatuses: {enabled: true, order: 6, isOptional: true, permission: undefined},
  progressBar: {enabled: true, order: 7, isOptional: true, permission: undefined},
  programType: {enabled: false, order: 8, isOptional: true, permission: undefined},
  createdAt: {enabled: false, order: 9, isOptional: true, permission: undefined},
  itemsIds: {enabled: false, order: 10, isOptional: true, permission: undefined},
  itemsTypes: {enabled: false, order: 11, isOptional: true, permission: undefined},
  itemsBarcodes: {enabled: false, order: 12, isOptional: true, permission: undefined},
  referenceIds: {enabled: false, order: 13, isOptional: true, permission: undefined},
  billingOrder: {enabled: false, order: 14, isOptional: true, permission: undefined},
  linePrice: {enabled: false, order: 15, isOptional: true, permission: undefined},
  tags: {enabled: false, order: 16, isOptional: true, permission: undefined},
  planned: {enabled: false, order: 17, isOptional: true, permission: undefined},
  gap: {enabled: false, order: 18, isOptional: true, permission: undefined},
  pods: {enabled: false, order: 19, isOptional: true, permission: undefined},
  itemsDescription: {enabled: false, order: 20, isOptional: true, permission: undefined}
}

const fulfillmentStepsTableColumnsMap = {
  displayStatus: {enabled: true, order: 1, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  line: {enabled: true, order: 2, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  pickupTask: {enabled: true, order: 3, permission: undefined, isOptional: true, size: TableColumnSizeType.medium},
  dropoffTask: {enabled: true, order: 4, permission: undefined, isOptional: true, size: TableColumnSizeType.medium},
  agent: {enabled: true, order: 5, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  attempts: {enabled: true, order: 6, permission: undefined, isOptional: true, size: TableColumnSizeType.medium},
  programType: {enabled: false, order: 7, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  createdAt: {enabled: false, order: 8, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  vehicle: {enabled: false, order: 9, permission: undefined, isOptional: true, size: TableColumnSizeType.medium},
  price: {enabled: false, order: 10, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  resource: {enabled: false, order: 11, permission: undefined, isOptional: true, size: TableColumnSizeType.medium},
  account: {enabled: false, order: 12, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  tags: {enabled: false, order: 13, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  referenceIds: {enabled: false, order: 14, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  itemsIds: {enabled: false, order: 15, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  itemsTypes: {enabled: false, order: 16, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  itemsBarcodes: {enabled: false, order: 17, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  operationalUnits: {enabled: false, order: 18, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  pods: {enabled: false, order: 19, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  itemsDescription: {enabled: false, order: 20, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  carrier: {enabled: false, order: 21, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  recurringServiceTemplateId: {enabled: true, order: 22, permission: undefined, isOptional: true, size: TableColumnSizeType.small},
  // skills : {enabled: false, order: 10, permission: undefined},
}

const stepsActions = {
  CreateVoucher: {
    id: 'CreateVoucher',
    title: 'Create Voucher',
    icon: 'tag',
    permission: ''
  },
  CancelLeg: {
    id: 'CancelLeg',
    title: 'Cancel Leg',
    icon: 'close-circle-outline',
    permission: ''
  },
  ManualHandle: {
    id: 'ManualHandle',
    title: 'Complete manually',
    icon: 'check-circle',
    permission: 'services.actions.manual'
  },
  SendToPlanning: {
    id: 'SendToPlanning',
    title: 'Send to planning',
  },
  SendToDispatch: {
    id: 'SendToDispatch',
    title: 'Send to dispatch',
  },
};

const attemptsActions = {
  Assign: {
    id: 'AssignAgent',
    title: 'Assign agent',
    icon: 'agent',
    permission: 'services.actions.assign'
  },
  AutoAssign: {
    id: 'AutoAssignAgent',
    title: 'Auto assign agent',
    icon: 'assign-outline',
    permission: 'services.actions.assign'
  },
  MultiAssign: {
    id: 'MultiAssign',
    title: 'Multi assign',
    icon: 'assign-outline',
    permission: 'services.actions.assign',
    isBulk: true
  },
  AssignRoute: {
    id: 'AssignToRoute',
    title: 'Assign to route',
    icon: 'route',
    permission: 'routes.list'
  },
  Cancel: {
    id: 'CancelService',
    title: 'Cancel service',
    icon: 'close-circle',
    permission: 'services.actions.delete'
  },
  Reset: {
    id: 'Reset',
    title: 'Reset',
    icon: 'reset',
    permission: 'services.actions.reset'
  },
  Note: {
    id: 'AddNote',
    title: 'Add note',
    icon: 'note',
    permission: 'services.actions.manual'
  },
  CreateRoute: {
    id: 'CreateRoute',
    title: 'Create route',
    icon: 'route',
    permission: 'routes.list'
  },
  CreateVoucher: {
    id: 'CreateVoucher',
    title: 'Create Voucher',
    icon: 'contract',
    permission: 'routes.list'
  },
  AssignResourceAllocation: {
    id: 'AssignResourceAllocation',
    title: 'Add to resource',
    icon: 'allocation',
    permission: 'fleetManagement.allocations.list'
  },
};

const fulfillmentStepServiceActions = {
  CreateVoucher: stepsActions.CreateVoucher,
  CancelLeg: stepsActions.CancelLeg,
  ManualHandle: stepsActions.ManualHandle,
  SendToPlanning: stepsActions.SendToPlanning,
  SendToDispatch: stepsActions.SendToDispatch
};

const fulfillmentAttemptsServiceActions = {
  Assign: attemptsActions.Assign,
  AutoAssign: attemptsActions.AutoAssign,
  MultiAssign: attemptsActions.MultiAssign,
  AssignRoute: attemptsActions.AssignRoute,
  Cancel: attemptsActions.Cancel,
  Reset: attemptsActions.Reset,
  Note: attemptsActions.Note,
  CreateRoute: attemptsActions.CreateRoute,
  CreateVoucher: attemptsActions.CreateVoucher,
  AssignResourceAllocation: attemptsActions.AssignResourceAllocation,
};

const fulfillmentStepActionsByStatusMap = {
  Operation: {
    Pending: [
      fulfillmentStepServiceActions.CreateVoucher,
      fulfillmentStepServiceActions.CancelLeg,
      fulfillmentStepServiceActions.SendToPlanning,
      fulfillmentStepServiceActions.SendToDispatch
    ],
    Scheduled: [
      fulfillmentStepServiceActions.ManualHandle,
      fulfillmentStepServiceActions.CancelLeg,
      fulfillmentStepServiceActions.SendToPlanning,
      fulfillmentStepServiceActions.SendToDispatch
    ],
    Dispatched: [
      fulfillmentStepServiceActions.ManualHandle,
      fulfillmentStepServiceActions.CancelLeg,
      fulfillmentStepServiceActions.SendToPlanning,
      fulfillmentStepServiceActions.SendToDispatch
    ],
    Completed: [],
    Failed: [],
    OnHold: [],
    Canceled: [],
    Splitted: []
  },
  Delivery: {
    Pending: [
      fulfillmentStepServiceActions.CreateVoucher,
      fulfillmentStepServiceActions.CancelLeg,
      fulfillmentStepServiceActions.SendToPlanning,
      fulfillmentStepServiceActions.SendToDispatch
    ],
    Scheduled: [
      fulfillmentStepServiceActions.ManualHandle,
      fulfillmentStepServiceActions.CancelLeg,
      fulfillmentStepServiceActions.SendToPlanning,
      fulfillmentStepServiceActions.SendToDispatch
    ],
    Dispatched: [
      fulfillmentStepServiceActions.ManualHandle,
      fulfillmentStepServiceActions.CancelLeg,
      fulfillmentStepServiceActions.SendToPlanning,
      fulfillmentStepServiceActions.SendToDispatch
    ],
    Completed: [],
    Failed: [],
    OnHold: [],
    Canceled: [],
    Splitted: []
  }
};

const fulfillmentStepAttemptsActionsByStatusMap = {
  ThirdPartyService: {
    Assigned: [
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Unassigned: [
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Started: [
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Completed: [
      fulfillmentAttemptsServiceActions.Note
    ],
    Canceled: [
      fulfillmentAttemptsServiceActions.Note,
    ],
  },
  Operation: {
    InAuction: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
      fulfillmentAttemptsServiceActions.CreateRoute
    ],
    InMarket: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
      fulfillmentAttemptsServiceActions.CreateRoute
    ],
    Assigned: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Unassigned: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
      fulfillmentAttemptsServiceActions.CreateRoute
    ],
    Started: [
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Aborted: [
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
    ],
    Completed: [
      fulfillmentAttemptsServiceActions.Note,
    ],
    Canceled: [
      fulfillmentAttemptsServiceActions.Note,
    ],
    ManualHandled: [
      fulfillmentAttemptsServiceActions.Note,
    ]
  },
  Delivery: {
    InAuction: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
      fulfillmentAttemptsServiceActions.CreateRoute
    ],
    InMarket: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
      fulfillmentAttemptsServiceActions.CreateRoute
    ],
    Assigned: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Unassigned: [
      fulfillmentAttemptsServiceActions.Assign,
      fulfillmentAttemptsServiceActions.AutoAssign,
      fulfillmentAttemptsServiceActions.MultiAssign,
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
      fulfillmentAttemptsServiceActions.CreateRoute
    ],
    Started: [
      fulfillmentAttemptsServiceActions.AssignRoute,
      fulfillmentAttemptsServiceActions.AssignResourceAllocation,
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note
    ],
    Aborted: [
      fulfillmentAttemptsServiceActions.Reset,
      fulfillmentAttemptsServiceActions.Cancel,
      fulfillmentAttemptsServiceActions.Note,
    ],
    Completed: [
      fulfillmentAttemptsServiceActions.Note,
    ],
    Canceled: [
      fulfillmentAttemptsServiceActions.Note,
    ],
    ManualHandled: [
      fulfillmentAttemptsServiceActions.Note,
    ]
  }
};

const fulfillmentStepItemSections = {
  timeWindow: true,
  taskLocation: true,
  status: true,
  packagesData: true,
  stepType: true,
  account: true,
  labels: true
}

const fulfillmentStepsGroupStatuses = {
  [FulfillmentStepDisplayStatusGroupType.onHold]: [FulfillmentStepDisplayStatusType.OnHold],
  [FulfillmentStepDisplayStatusGroupType.pending]: [FulfillmentStepDisplayStatusType.NotScheduled, FulfillmentStepDisplayStatusType.Unassigned],
  [FulfillmentStepDisplayStatusGroupType.assigned]: [FulfillmentStepDisplayStatusType.Assigned],
  [FulfillmentStepDisplayStatusGroupType.pickupInProgress]: [FulfillmentStepDisplayStatusType.HeadingPickup, FulfillmentStepDisplayStatusType.ArrivedPickup, FulfillmentStepDisplayStatusType.PickedUp],
  [FulfillmentStepDisplayStatusGroupType.destinationInProgress]: [FulfillmentStepDisplayStatusType.HeadingDestination, FulfillmentStepDisplayStatusType.ArrivedDestination],
  [FulfillmentStepDisplayStatusGroupType.completed]: [FulfillmentStepDisplayStatusType.Completed],
  [FulfillmentStepDisplayStatusGroupType.problem]: [FulfillmentStepDisplayStatusType.ContactNotAvailable],
  [FulfillmentStepDisplayStatusGroupType.canceled]: [FulfillmentStepDisplayStatusType.Canceled]
}

angular
  .module('bringoz.admin.fulfillment')
  .constant('FulfillmentConstants', {
    fulfillmentStatuses: fulfillmentStatuses,
    fulfillmentDisplayStatuses: fulfillmentDisplayStatuses,
    fulfillmentStepStatuses: fulfillmentStepStatuses,
    fulfillmentMiles: fulfillmentMiles,
    fulfillmentLinesTableColumnsMap: fulfillmentLinesTableColumnsMap,
    fulfillmentStepsTableColumnsMap: fulfillmentStepsTableColumnsMap,
    fulfillmentStepActionsByStatusMap: fulfillmentStepActionsByStatusMap,
    fulfillmentStepAttemptsActionsByStatusMap: fulfillmentStepAttemptsActionsByStatusMap,
    fulfillmentStepsActions: stepsActions,
    fulfillmentAttemptsServiceActions: attemptsActions,
    fulfillmentStepItemSections: fulfillmentStepItemSections,
    fulfillmentStepsGroupStatuses: fulfillmentStepsGroupStatuses
  });
